// Global function that can be called from PHP
function waitForContent(contentSelector, callback, maxWait = 2000) {
    const contentContainer = document.querySelector(contentSelector);
    const hasH2s = document.querySelectorAll('h2').length > 0;
    
    if (contentContainer && hasH2s) {
        callback();
        return;
    }
    
    const startTime = Date.now();
    const observer = new MutationObserver(() => {
        const contentContainer = document.querySelector(contentSelector);
        const hasH2s = document.querySelectorAll('h2').length > 0;
        
        if (contentContainer && hasH2s) {
            observer.disconnect();
            callback();
        } else if (Date.now() - startTime > maxWait) {
            observer.disconnect();
            console.warn('TOC build timeout: content not ready');
        }
    });
    
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

window.buildLearningCenterTOC = function (contentSelector = '.learning-center-content') {
    waitForContent(contentSelector, () => {
        buildDynamicTOC(contentSelector);
        setupScrollBehavior();
    });
};

window.buildQuickStartGuideTOC = function (contentSelector = '.quick-start-guide-content') {
    waitForContent(contentSelector, () => {
        buildDynamicTOC(contentSelector);
        setupScrollBehavior();
    });
};


function buildDynamicTOC(contentSelector) {
    // Find the TOC container
    const tocContainer = document.querySelector('.list-none');
    if (!tocContainer) {
        console.log('TOC container not found');
        return;
    }

    // Clear existing TOC links
    tocContainer.innerHTML = '';

    // Define blocks to exclude from TOC (same as PHP)
    const excludedBlocks = [
        'footer-cta',
        'mid-cta',
        'resources'
    ];

    // ACF blocks render with an "acf/" prefix on data-component (e.g. "acf/footer-cta")
    const isExcludedComponent = (componentType) => {
        return excludedBlocks.includes(componentType.replace(/^acf\//, ''));
    };

    // Remove excluded blocks from DOM before processing
    const contentContainer = document.querySelector(contentSelector);
    if (contentContainer) {
        const excludedElements = contentContainer.querySelectorAll('[data-component]');
        excludedElements.forEach(element => {
            const componentType = element.getAttribute('data-component');
            if (isExcludedComponent(componentType)) {
                element.style.display = 'none'; // Hide temporarily
            }
        });
    }

    // Find all h2 elements after React components have rendered
    const allH2s = document.querySelectorAll('h2');

    // Build TOC dynamically
    allH2s.forEach((h2, index) => {
        // Skip if h2 is inside excluded blocks
        const isInExcludedBlock = excludedBlocks.some(blockType => {
            return h2.closest(`[data-component="${blockType}"], [data-component="acf/${blockType}"]`);
        });

        if (isInExcludedBlock) {
            return;
        }

        // Generate ID if not present
        const id = h2.id || `section-${index}`;
        h2.id = id;

        // Create list item
        const li = document.createElement('li');
        li.className = 'my-[16rem]';

        // Create link
        const link = document.createElement('a');
        link.href = `#${id}`;
        link.className = 'toc-link';
        link.setAttribute('data-target', id);
        link.textContent = h2.textContent;
        link.style.display = 'block';

        // Add click handler
        link.addEventListener('click', function (e) {
            e.preventDefault();
            const targetElement = document.getElementById(id);

            if (targetElement) {
                const headerOffset = 120;

                const elementPosition = targetElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        });

        li.appendChild(link);
        tocContainer.appendChild(li);
    });

    // Restore excluded blocks visibility
    if (contentContainer) {
        const hiddenElements = contentContainer.querySelectorAll('[data-component]');
        hiddenElements.forEach(element => {
            element.style.display = ''; // Restore original display
        });
    }

}

function setupScrollBehavior() {
    // Get all TOC links (now dynamically created)
    const tocLinks = document.querySelectorAll('.toc-link');

    if (tocLinks.length === 0) {
        console.log('No TOC links found');
        return;
    }

    // Create Intersection Observer for scroll-based color changing
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const targetId = entry.target.id;
            const tocLink = document.querySelector(`[data-target="${targetId}"]`);

            if (entry.isIntersecting) {
                // Remove active class from all links
                tocLinks.forEach(link => {
                    link.classList.remove('active');
                });

                // Add active class to current link
                if (tocLink) {
                    tocLink.classList.add('active');
                }
            }
        });
    }, {
        rootMargin: '-20% 0px -70% 0px',
        threshold: 0.1
    });

    // Observe all section headings (including those from React components)
    const sections = document.querySelectorAll('h2[id]');

    sections.forEach(section => {
        observer.observe(section);
    });
}